export function parseCookie(value) {
    if (!value) return;
    const json = window.atob(value);
    return JSON.parse(json);
}



// WEBPACK FOOTER //
// ./src/services/cookie.js